import {
  BrowserRouter as Router,
  Routes,
  Route,
  Navigate,
} from "react-router-dom";
import React from "react";
import { Provider, useSelector } from "react-redux";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { PersistGate } from "redux-persist/integration/react";
import Login from "./Components/Authenticate/Login";
import "./App.css";
import Dashboard from "./Components/Dashboard/Dashboard";
import Tickets from "./Components/Tickets/Tickets";
import TicketDetail from "./Components/TicketDetail/TicketDetail";
import Clients from "./Components/Clients/Client";
import MainClient from "./Components/ClientDetail/MainClient";
import Inbox from "./Components/Inbox/Inbox";
import Users from "./Components/User/Users";
import Setup from "./Components/ClientDetail/PracticeSetup/Childs/Setup";
import { store, persistor } from "./store";
import HideInjectedElements from "./Shared/HideInjectedElements";
import { checkRouteAccess } from "./utils/route";

const ProtectedRoute = ({ children }) => {
  const sharedData = useSelector((state) => state.SharedLayoutData);
  const firstName = sessionStorage.getItem("firstName");
  const currentUrl = window.location.href;

  const isAuth = checkRouteAccess(currentUrl, sharedData);

  if (firstName) {
    return isAuth ? children : <Navigate to="/dashboard" />;
  } 
    return <Navigate to="/" />;
  
};

const MissingRoute = () => <Navigate to={{ pathname: "/" }} />;

const queryClient = new QueryClient();

const App = () => (
    <QueryClientProvider client={queryClient}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <HideInjectedElements />
          <Router>
            <Routes>
              <Route path="*" element={<MissingRoute />} />
              <Route path="/" element={<Login />} />
              <Route
                path="/dashboard"
                element={
                  <ProtectedRoute>
                    <Dashboard />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/tickets"
                element={
                  <ProtectedRoute>
                    <Tickets />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/ticketDetail"
                element={
                  <ProtectedRoute>
                    <TicketDetail />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/clients"
                element={
                  <ProtectedRoute>
                    <Clients />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/client-detail"
                element={
                  <ProtectedRoute>
                    <MainClient />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/inbox"
                element={
                  <ProtectedRoute>
                    <Inbox />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/users"
                element={
                  <ProtectedRoute>
                    <Users />
                  </ProtectedRoute>
                }
              />
              <Route
                path="/setup"
                element={
                  <ProtectedRoute>
                    <Setup />
                  </ProtectedRoute>
                }
              />
            </Routes>
          </Router>
        </PersistGate>
      </Provider>
    </QueryClientProvider>
  )

export default App;
